import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import useCsrfPageNeedsReload from "@/helpers/customHooks/useCsrfPageNeedsReload";

export default function PageSetup(props: {
  locale: string;
  csrfToken: string;
}) {
  const { t } = useTranslation();
  const router = useRouter();
  const { query } = router;
  const { brand, data, country, mailto } = query;
  const isDevelopment =
    process.env.NODE_ENV === "development" ||
    (globalThis.window !== undefined &&
      globalThis.location.href.includes("localhost"));

  const [activeStep, setActiveStep] = useState(0);
  const [succeededStep, setSucceededStep] = useState(0);

  const isSessionExpired = useCsrfPageNeedsReload(
    "csrf_token",
    '[name="csrf_token"]',
  );
  useEffect(() => {
    localStorage.setItem("csrf_token", props.csrfToken);
  }, [props.csrfToken]);

  return {
    t,
    router,
    query,
    brand,
    data,
    country,
    mailto,
    isDevelopment,
    activeStep,
    setActiveStep,
    succeededStep,
    setSucceededStep,
    isSessionExpired,
  };
}
